import {
  InteractionRequiredAuthError,
  InteractionStatus,
} from "@azure/msal-browser";

const loginRequest = {
  scopes: ["api://1b284f5e-aba2-4e47-84a6-c4a38e60a5ff/specialScope"],
};

export const onMsLogin = ({
  instance,
  navigate,
  inProgress,
  accounts,
  msLogin,
  setMsToken,
}) => {
  const getAccessToken = async () => {
    // console.log({ inProgress })
    const accessTokenRequest = {
      scopes: [
        `api://${process.env.REACT_APP_AZURE_AD_SERVER_CLIENT_ID}/specialScope`,
      ],
      account: accounts[0],
    };
    if (accounts[0] && inProgress === InteractionStatus.None) {
      return await instance
        .acquireTokenSilent(accessTokenRequest)
        .then((accessTokenResponse) => {
          // Acquire token silent success
          let accessToken = accessTokenResponse.accessToken;
          setMsToken(accessToken);
          return accessToken;
        })
        .catch((error) => {
          if (error instanceof InteractionRequiredAuthError) {
            instance
              .acquireTokenPopup(accessTokenRequest)
              .then(function (accessTokenResponse) {
                // Acquire token interactive success
                let accessToken = accessTokenResponse.accessToken;
                setMsToken(accessToken);
                return accessToken;
              })
              .catch(function (error) {
                // Acquire token interactive failure
                console.log(error);
              });
          }
          console.log(error);
        });
    } else {
      return null;
    }
  };

  ////////////////////////////////
  instance
    .loginPopup({
      ...loginRequest,
    })
    .then(async (MSResponse) => {
      // await getAccessToken().then(async (res) => {
      //   console.log("token response", { res });
      // });

      await msLogin({
        msToken: MSResponse.accessToken,
      });
    });
};
